module.exports = __webpack_public_path__ + "img/1480.2fffd9b7.png";